import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTopicPageViewsTopicEditor } from "../TopicPageViewsTopicEditorContext";
import TopicPageEditorDivider from "../../TopicPageEditorDivider";
import TopicPageViewsTopicListPostEditor from "./TopicPageViewsTopicListPostEditor";
import TopicPageViewsTopicListPostWithListNavigation from "./TopicPageViewsTopicListPostWithListNavigation";
const TopicPageViewsTopicListPostsPost = (props)=>{
    const { post , topicId , isSortEnabled , context , index , topicNodeId  } = props;
    const { id , nodeId , title , display  } = post;
    const { color  } = display;
    const { state , dispatch  } = useTopicPageViewsTopicEditor();
    const openEditPostEditor = state.editor === "EDIT_POST_DESCRIPTION" && state.editorPosition === post.id;
    const openEditDividerEditor = state.editor === "EDIT_DIVIDER" && state.editorPosition === post.id;
    const closeEditor = useCallback(()=>{
        dispatch({
            type: "CLOSE_EDITOR"
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !openEditPostEditor && !openEditDividerEditor && /*#__PURE__*/ _jsx(TopicPageViewsTopicListPostWithListNavigation, {
                post: post,
                isSortEnabled: isSortEnabled,
                topicNodeId: topicNodeId,
                topicId: topicId,
                index: index,
                context: context
            }),
            openEditDividerEditor && color && /*#__PURE__*/ _jsx(TopicPageEditorDivider, {
                dividerId: id,
                dividerNodeId: nodeId,
                title: title || "No title",
                color: color,
                closeEditor: closeEditor,
                open: "desktop"
            }),
            /*#__PURE__*/ _jsx(TopicPageViewsTopicListPostEditor, {
                topicId: topicId,
                post: post
            })
        ]
    });
};
export default TopicPageViewsTopicListPostsPost;
